import {Component, ViewChild, ElementRef} from '@angular/core';
import {IPopupQuery} from "../../interfaces/IPopupQuery";
import {Session} from "../../services/Session";
import {Reports} from "../../services/Reports";
import {Notify} from "../../services/Notify";
import {IHPG} from "../../interfaces/IHPG";
import {IHPGRecord} from "../../interfaces/IHPG";
import {Helpers} from "../../services/Helpers";

@Component({
  templateUrl: 'report.html',
  selector: 'hpg-report'
})
export class HPGReportCmp {
  public results:IHPGRecord[] = [];
  public loading = false;
  public queries:IPopupQuery[] = [];
  public contract = '';
  public loadedContract = '';
  @ViewChild('tbl') tbl:ElementRef;
  private n = new Notify();

  constructor(private session:Session, private reports:Reports) {
    this.session.redirectIfNotAuth();
  }

  load() {
    if (!this.contract) {
      return;
    }
    this.results = [];
    this.loading = true;
    this.queries = [];
    this.loadedContract = this.contract;
    this.reports.getHPGReport(this.contract).subscribe((report)=> {
      this.results = report.report;
      this.queries = [{query: report.query, name: 'Query'}];
      this.loading = false;
    }, (err)=> {
      this.loading = false;
      this.n.httpErr(err);
    });
  }

  exportCSV() {
    if (!this.results || this.results.length < 1) {
      return;
    }
    let h = new Helpers();
    h.exportCsv(this.tbl, 'hpg_report_contract_' + this.contract + '.csv');
  }
}
